import React, { useState } from 'react';
import SubmitArt from './Test';
import mo from '../Components/image/ChatGPT Image Jul 24, 2025, 06_40_45 PM.png';

function App() {
  return (
    <div className='app-container'>
      <br />

      <h1 className='centerani'>$ANI Artist Portal</h1>
      <SubmitArt />

      <div className='video-background mobile-bg'>
        <img src={mo} alt='Mobile Background' className='image-content' />
        <div className='overlay'></div>
      </div>
    </div>
  );
}

export default App;
